import * as Yup from 'yup'

import { EMPTY_LIST } from '../../../constants/common'
import {
  EntityActionTypeSelectOptionValue,
  getEntityActionTypeSelectOptions,
} from '../../Entity'
import { formValidationSchemaNoChanged } from '../../Form'
import { FORMIK_ENTITY_ACTION_CONFIG_FIELDS_TYPE_SELECT_NAME } from '../../Formik'

import {
  REQUEST_EDIT_STATUS_DEFAULT_VALUE,
  REQUEST_EDIT_STATUS_FIELD_NAME,
} from './RequestEditStatusModal.constants'

export function getRequestEditStatusValidationSchema(
  initialValues,
  needToCheckNoChanges
) {
  return Yup.object({
    [REQUEST_EDIT_STATUS_FIELD_NAME]: Yup.object().required(() => true),
  }).when(EMPTY_LIST, {
    is: () => needToCheckNoChanges,
    then: schema =>
      schema.concat(formValidationSchemaNoChanged({ initialValues })),
  })
}

export function getRequestEditStatusModalInitialValues(item, fieldName) {
  return {
    [fieldName || REQUEST_EDIT_STATUS_FIELD_NAME]: {
      id: item?.status || REQUEST_EDIT_STATUS_DEFAULT_VALUE,
    },
  }
}

export function getRequestEditStatusModalWithActionTypesInitialValues(
  item,
  fieldName
) {
  const actionTypeOptions = getEntityActionTypeSelectOptions()

  return {
    ...getRequestEditStatusModalInitialValues(item, fieldName),
    [FORMIK_ENTITY_ACTION_CONFIG_FIELDS_TYPE_SELECT_NAME]:
      actionTypeOptions[EntityActionTypeSelectOptionValue.Edit],
  }
}

export function getRequestEditStatusModalSubmitPayload(values) {
  return {
    [REQUEST_EDIT_STATUS_FIELD_NAME]: values[REQUEST_EDIT_STATUS_FIELD_NAME].id,
  }
}
